module.exports = __webpack_public_path__ + "img/stock6.df7e1583.png";